import type { ValidatorType } from "shelving";
import { AllowStringSchema, BooleanSchema, DATA, EMAIL, INTEGER, PASSWORD, pickProps } from "shelving";
import { PRIVACY } from "../util/privacy.js";
import { PROFILE_SCHEMA } from "./profile.js";

/**
 * User private data (stored in the 'users' collection).
 * Stores information about each user that should never be accessible to any other user.
 */
export const USER_SCHEMA = DATA({
	// Privacy.
	postPrivacy: new AllowStringSchema({ ...PRIVACY, title: "Created posts" }),
	challengePrivacy: new AllowStringSchema({ ...PRIVACY, title: "Created challenges" }),
	attemptPrivacy: new AllowStringSchema({ ...PRIVACY, title: "Created challenges" }),
	earnedPrivacy: new AllowStringSchema({ ...PRIVACY, title: "Earned rewards" }),
	approval: new BooleanSchema({ title: "Approve new followers", description: "Follow requests must be approved by you.", value: true }),
	// Read counts.
	noticeDate: INTEGER, // Last time the user read their notifications.
});
export type UserData = ValidatorType<typeof USER_SCHEMA>;

export const REGISTER_SCHEMA = DATA({
	username: PROFILE_SCHEMA.props.username,
	email: EMAIL,
	password: PASSWORD,
});
export type RegisterData = ValidatorType<typeof REGISTER_SCHEMA>;

export const LOGIN_SCHEMA = DATA({
	email: EMAIL,
	password: PASSWORD,
});
export type LoginData = ValidatorType<typeof LOGIN_SCHEMA>;

export const PRIVACY_FORM_SCHEMA = DATA(
	pickProps(
		USER_SCHEMA.props, //
		"postPrivacy",
		"challengePrivacy",
		"attemptPrivacy",
		"earnedPrivacy",
		"approval",
	),
);
